/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ask_ValuesInputs */

const en_ui_onboarding_ask_values = /** @type {(inputs: Ui_Onboarding_Ask_ValuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 · A few values about you`)
};

const de_ui_onboarding_ask_values = /** @type {(inputs: Ui_Onboarding_Ask_ValuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 · Ein paar Werte über dich`)
};

/**
* | output |
* | --- |
* | "2 · A few values about you" |
*
* @param {Ui_Onboarding_Ask_ValuesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ask_values = /** @type {((inputs?: Ui_Onboarding_Ask_ValuesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ask_ValuesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ask_values(inputs)
	return de_ui_onboarding_ask_values(inputs)
});